var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBackLeftOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1075.1 981.1",
    style: {
      enableBackground: "new 0 0 1075.1 981.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#536280;}\n\t.st1{fill:#081B45;}\n\t.st2{fill:#9A6E55;}\n\t.st3{fill:#245EA5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,972 0,903.8 993.4,0.2 1062.9,0.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.8,925.3 1011.1,0.8 0,0.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0.3,981.1 634.2,402.7 620.3,392.5 0.7,958.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "615.8,396.3 629.1,407.5 1075.1,0 1050.6,0  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBackLeftOver);
export default __webpack_public_path__ + "static/media/HomeBackLeftOver.182ebe7ecf714e771a7f8239667dbe64.svg";
export { ForwardRef as ReactComponent };